import {omniFetch} from "~/utils/fetch";
import {config} from "~/utils/config";

export function voteDetail({shareId, shopProductId}) {
  return omniFetch({
    url: config.v1Path + config.voteDetailPath,
    method: "post",
    params: {shareId, shopProductId}
  })
}

export function voteSubmit({shareId, optionLabel, descriptionText}) {
  return omniFetch({
    url: config.v1Path + config.voteSubmitPath,
    method: "post",
    params: {shareId, optionLabel, descriptionText}
  })
}

export function votePage({pageIndex, pageSize}) {
  return omniFetch({
    url: config.v1Path + config.votePagePath,
    method: "post",
    params: {pageIndex, pageSize}
  })
}

export function voteQueryPushSwitch({}) {
  return omniFetch({
    url: config.v1Path + config.voteQueryPushSwitchPath,
    method: "post",
    params: {}
  })
}

// 设置商品投票结果的通知总开关 （全部PDP投票）
export function voteEditPushSwitch({action}) {
  return omniFetch({
    url: config.v1Path + config.voteEditPushSwitchPath,
    method: "post",
    params: {action}
  })
}

// 设置某个PDP某档次分数投票结果的通知开关
export function voteEditOptionPushSwitch({shareId, productId, optionLabels, action}) {
  return omniFetch({
    url: config.v1Path + config.voteEditOptionPushSwitchPath,
    method: "post",
    params: {shareId, productId, optionLabels, action}
  })
}

// 某个PDP删除投票记录
export function voteRemove({shareId, shopProductId}) {
  return omniFetch({
    url: config.v1Path + config.voteRemovePath,
    method: "post",
    params: {shareId, shopProductId}
  })
}
